import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import packageApi from 'src/api/package'

export const fetchPackageByStoreId = createAsyncThunk(
  'package/fetchPackageByStoreId',
  async (storeId) => {
    const response = await packageApi.getAllPackageByStoreId(storeId)
    // console.log("Package Redux: ", response);
    return response
  }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  loading: true,
  error: '',
  status: '',
  packages: [],
}

const slice = createSlice({
  name: 'package',
  initialState,
  reducers: {
    createPackage(oldState, payload) {
      let newPackage = payload.payload
      // console.log(newPackage)
      // let packages = [...oldState.packages]
      oldState.packages = [...oldState.packages, newPackage]
    },
    updatePackage(oldState, payload) {
      let newPackage = payload.payload
      // console.log(newPackage)
      // let packages = [...oldState.packages]
      let filterPackage = [...oldState.packages].filter(
        (each) => each.id !== newPackage.id
      )

      oldState.packages = [...filterPackage, newPackage]
    },
    // delete 就是把status 改成0 让他无效
    deletePackage(oldState, action) {
      let deleteId = action.payload.id
      // console.log('deleteId: ', deleteId)
      let packages = [...oldState.packages]
      let filterPackage = packages.filter((each) => each.id !== deleteId)
      // console.log(filterPackage)
      oldState.packages = filterPackage
    },

    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },

    setReload(oldState, action) {
      oldState.reload = action.payload
    },
  },
  extraReducers: {
    [fetchPackageByStoreId.pending]: (state, action) => {
      state.status = 'loading'
      state.loading = true
    },
    [fetchPackageByStoreId.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      // let holdingPackages = action.payload;
      // let basket = [];
      // holdingPackages.map(item => {
      //     if(item.status == 1) {
      //         basket.push(item)
      //     }
      // })
      // state.packages = basket
      state.packages = action.payload
      state.loading = false
    },
    [fetchPackageByStoreId.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

// export const setPackageRedux = (detail) => (dispatch) => {
//     dispatch(slice.action.setPackageRedux(detail));
// }

export const createPackage = (requestBody) => async (dispatch) => {
  // console.log('dispatch createPackage ：', requestBody)
  const result = await packageApi.savePackage(requestBody)
  dispatch(slice.actions.createPackage(result))
}

export const updatePackage = (requestBody) => async (dispatch) => {
  // console.log('dispatch updatePackage ：', requestBody)
  const result = await packageApi.updatePackage(requestBody)
  // console.log('dispatchresult： ', result)
  dispatch(slice.actions.updatePackage(result))
}

export const deletePackage = (requestBody) => async (dispatch) => {
  const result = await packageApi.updatePackage(requestBody)
  // console.log('要删除的package: ', result)
  dispatch(slice.actions.deletePackage(result))
}

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

export default slice
